/** コンサルタント 案件メンバー：役割 プロジェクト責任者 */
export const RFP_OFFER_MEMBER_ROLE_ADMIN = {
    label: 'プロジェクト責任者',
    value: 1,
};
/** コンサルタント 案件メンバー：役割 プロジェクトマネージャー */
export const RFP_OFFER_MEMBER_ROLE_MANAGER = {
    label: 'プロジェクトマネージャー',
    value: 2,
};
/** コンサルタント 案件メンバー：役割 スタッフ */
export const RFP_OFFER_MEMBER_ROLE_STAFF = {
    label: 'スタッフ',
    value: 3,
};
/** コンサルタント 案件メンバー：役割 アドバイザー */
export const RFP_OFFER_MEMBER_ROLE_ADVISER = {
    label: 'アドバイザー',
    value: 4,
};
/** コンサルタント 案件メンバー：役割の一覧 */
export const RFP_OFFER_MEMBER_ROLES = [
    RFP_OFFER_MEMBER_ROLE_ADMIN,
    RFP_OFFER_MEMBER_ROLE_MANAGER,
    RFP_OFFER_MEMBER_ROLE_STAFF,
    RFP_OFFER_MEMBER_ROLE_ADVISER,
];
